/**
 * Exportaciones sensibles como permisos de función (blockedFeatures).
 * Por defecto: permitido si el usuario tiene el módulo fuente; bloquear aquí revoca export aunque tenga el módulo.
 * Sincronizar IDs con smart_back export-function-permissions.ts / permission-guard VALID_BLOCKED_FEATURES.
 */
export const EXPORT_BLOCKABLE_FEATURES = [
  {
    id: 'export_libro_mayor',
    label: 'Bloquear exportación Libro Mayor',
    description: 'Impide Excel/descargas de Libro Mayor. Requiere acceso al módulo Libro Mayor si no está bloqueado.',
    parentModule: 'libro_mayor',
  },
  {
    id: 'export_libro_diario',
    label: 'Bloquear exportación Libro Diario',
    description: 'Impide Excel/descargas de Libro Diario. Requiere acceso al módulo Libro Diario si no está bloqueado.',
    parentModule: 'libro_diario',
  },
  {
    id: 'export_conciliacion',
    label: 'Bloquear exportación Conciliación',
    description: 'Impide exportar conciliación bancaria. Requiere acceso al módulo Conciliación si no está bloqueado.',
    parentModule: 'conciliacion',
  },
  {
    id: 'export_eerr',
    label: 'Bloquear exportación EERR',
    description: 'Impide Excel de Estado de Resultados. Requiere acceso al módulo EERR si no está bloqueado.',
    parentModule: 'eerr',
  },
  {
    id: 'export_flujo_caja',
    label: 'Bloquear exportación Flujo de Caja',
    description: 'Impide Excel de flujo de caja. Requiere acceso al módulo Flujo de Caja si no está bloqueado.',
    parentModule: 'flujo_caja',
  },
  {
    id: 'export_reportes_cobranza',
    label: 'Bloquear exportación Cobranza',
    description: 'Impide exportar reportes de cobranza. Requiere acceso al módulo Reporte de Cobranza si no está bloqueado.',
    parentModule: 'reportes_cobranza',
  },
  {
    id: 'export_reportes_proveedores',
    label: 'Bloquear exportación Proveedores',
    description: 'Impide exportar reportes de proveedores. Requiere acceso al módulo correspondiente si no está bloqueado.',
    parentModule: 'reportes_proveedores',
  },
  {
    id: 'export_reportes_ventas',
    label: 'Bloquear exportación Ventas (documentos)',
    description: 'Impide libros/export de ventas. Requiere acceso al módulo Documentos (DTEs) si no está bloqueado.',
    parentModule: 'documentos_tributarios',
  },
  {
    id: 'export_reportes_compras',
    label: 'Bloquear exportación Compras (documentos)',
    description: 'Impide libros/export de compras. Requiere acceso al módulo Documentos (DTEs) si no está bloqueado.',
    parentModule: 'documentos_tributarios',
  },
  {
    id: 'export_agenda',
    label: 'Bloquear exportación Agenda',
    description: 'Impide exportar contactos/agenda. Requiere acceso al módulo Contactos si no está bloqueado.',
    parentModule: 'agenda',
  },
  {
    id: 'export_eoaf',
    label: 'Bloquear exportación EOAF',
    description: 'Impide exportar EOAF. Requiere acceso al módulo EOAF si no está bloqueado.',
    parentModule: 'eoaf',
  },
  {
    id: 'export_documentos',
    label: 'Bloquear exportación Documentos',
    description: 'Impide exportar documentos, rendiciones y libros auxiliares. Requiere acceso a Documentos (DTEs) si no está bloqueado.',
    parentModule: 'documentos_tributarios',
  },
  {
    id: 'export_api_movimientos',
    label: 'Bloquear API: Movimientos',
    description: 'Impide listados masivos de movimientos vía API. Requiere acceso a Conciliación si no está bloqueado.',
    parentModule: 'conciliacion',
  },
  {
    id: 'export_api_documentos',
    label: 'Bloquear API: Documentos',
    description: 'Impide listados masivos de documentos vía API. Requiere acceso a Documentos (DTEs) si no está bloqueado.',
    parentModule: 'documentos_tributarios',
  },
  {
    id: 'export_api_remuneraciones',
    label: 'Bloquear API: Remuneraciones',
    description: 'Impide export vía API de remuneraciones. Requiere acceso a Reporte RRHH si no está bloqueado.',
    parentModule: 'reportes_rrhh',
  },
  {
    id: 'export_api_libro_mayor',
    label: 'Bloquear API: Libro Mayor',
    description: 'Impide export vía API de libro mayor. Requiere acceso al módulo Libro Mayor si no está bloqueado.',
    parentModule: 'libro_mayor',
  },
  {
    id: 'export_api_contactos',
    label: 'Bloquear API: Contactos',
    description: 'Impide export vía API de contactos. Requiere acceso al módulo Contactos si no está bloqueado.',
    parentModule: 'agenda',
  },
  {
    id: 'export_api_reportes',
    label: 'Bloquear API: Reportes',
    description: 'Impide export vía API de reportes. Requiere acceso a algún módulo de Reportes si no está bloqueado.',
    parentModule: 'reportes',
  },
  {
    id: 'export_unmasked',
    optIn: true,
    label: 'Exportar sin enmascarar (soporte)',
    description: 'Permite a staff exportar con datos completos (RUT, nombres). Debe activarse explícitamente; por defecto los exports de staff van enmascarados.',
  },
]

export const EXPORT_BLOCKED_FEATURE_IDS = EXPORT_BLOCKABLE_FEATURES.filter((f) => !f.optIn).map((f) => f.id)
